<form
  class="form"
  [formGroup]="loginForm"
  (ngSubmit)="onSubmit()"
  #formRef="ngForm"
>
  <mat-form-field appearance="standard">
    <mat-label>Company Code</mat-label>
    <mat-select name="companyCode" formControlName="companyCode">
      <mat-option
        *ngFor="let companyCode of companyCodes"
        [value]="companyCode"
      >
        {{ companyCode }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="companyCode?.hasError('required')"
      >Company Code is required</mat-error
    >
  </mat-form-field>
  <mat-form-field appearance="standard">
    <mat-label>Email</mat-label>
    <input
      (focusout)="onEmailFocusOut()"
      matInput
      formControlName="email"
      type="text"
      required
    />
    <mat-error *ngIf="email?.hasError('required')">
      Email is required
    </mat-error>
    <mat-error *ngIf="email?.hasError('email')">
      Email isn't valid. Please enter a valid email.
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="standard">
    <mat-label>Password</mat-label>
    <input matInput formControlName="password" type="password" required />
    <mat-error *ngIf="password?.hasError('required')">
      Password is required
    </mat-error>
    <mat-error *ngIf="password?.hasError('minLength') && formRef.submitted">
      Password must be at least 6 characters
    </mat-error>
  </mat-form-field>
  <!-- <mat-form-field *ngIf="showRoleField">
    <mat-label>Role</mat-label>
    <mat-select name="role" formControlName="role">
      <mat-option [value]="'Foreman'">Foreman</mat-option>
      <mat-option [value]="'Service Tech'">Service Tech</mat-option>
    </mat-select>
    <mat-error *ngIf="loginForm.get('role')?.invalid">
      Please select the role you would like to login as.
    </mat-error>
  </mat-form-field> -->
  <div class="form-footer">
    <button mat-raised-button type="submit">Login</button>
  </div>
</form>
